import { ConditionParams } from "@omni/types/utils/productConfiguration";

const licensePlateProductSKUs = [
    "341819",
    "487684",
    "509641",
    "892028",
    "1054490",
    "1054491",
    "1054492",
    "1054493"
];

export const LicensePlateCondition = ({ sku }: ConditionParams) => {
    return !!sku && licensePlateProductSKUs.includes(sku);
};
